import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import $ from 'jquery';
import Popper from 'popper.js';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'normalize.css';
import App from './App/App';
import './index.scss';

setTimeout(()=> {
    ReactDOM.render(<App />, document.getElementById('root'));
}, 1500);
